/**
 * DepartmentBadges — zeigt das Freitext-Feld `department` als Badges.
 *
 * Tokenisiert anhand von Komma oder Semikolon. Beispiel:
 *   "BaE, BvB, AVGS"  →  [BaE] [BvB] [AVGS]
 *
 * Kein Bezug zu Stammdaten-Maßnahmen — bewusst flexibel für Vertretungen,
 * Sonderkonstellationen und freie Beschreibungen.
 */
import React from 'react';
import { Badge } from '../components/ui/badge';

const splitTokens = (text) =>
  (text || '')
    .split(/[,;]/)
    .map((s) => s.trim())
    .filter(Boolean);

export const DepartmentBadges = ({
  text,
  size = 'sm',
  emptyText = '-',
  testIdPrefix = 'department-badge',
}) => {
  const tokens = splitTokens(text);

  if (tokens.length === 0) {
    return <span className="text-sm text-muted-foreground">{emptyText}</span>;
  }

  const sizeClasses = size === 'md' ? 'text-sm px-2.5 py-0.5' : 'text-xs px-2 py-0.5';

  return (
    <div className="flex flex-wrap gap-1" data-testid={`${testIdPrefix}-container`}>
      {tokens.map((t, idx) => (
        <Badge
          key={`${idx}-${t}`}
          variant="secondary"
          className={`${sizeClasses} font-medium`}
          data-testid={`${testIdPrefix}-${idx}`}
        >
          {t}
        </Badge>
      ))}
    </div>
  );
};

export default DepartmentBadges;
